import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ItemEnvelope } from '../../../models/net/envelope/base/item-envelope';
import { Observable } from 'rxjs/internal/Observable';
import { HttpCrudFactory } from '../../../utilities/http-crud-factory';
import { DeleteResult } from '../../../models/net/result/crud/delete-result';
import { UpdateResult } from '../../../models/net/result/crud/update-result';
import { ReadResult } from '../../../models/net/result/crud/read-result';
import { CreateResult } from '../../../models/net/result/crud/create-result';

@Injectable({
    providedIn: 'root'
})

export class CrudService {

    public _apiBaseUrl: string = "";
    public _controllerName: string = "production";

    public constructor(public http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string, @Inject("") controllerName: string) {

        this._apiBaseUrl = apiBaseUrl;
        this._controllerName = controllerName;
    }

    public create(envelope: ItemEnvelope): Observable<CreateResult | null> {

        const result = HttpCrudFactory.create<ItemEnvelope>(this.http, this._controllerName, this._apiBaseUrl, envelope);

        return result;
    }

    public read(itemId: number): Observable<ReadResult | null> {

        const result = HttpCrudFactory.read(this.http, this._controllerName, this._apiBaseUrl, itemId);

        return result;
    }

    public update(envelope: ItemEnvelope): Observable<UpdateResult | null> {

        const result = HttpCrudFactory.update<ItemEnvelope>(this.http, this._controllerName, this._apiBaseUrl, envelope, envelope.ItemId);

        return result;
    }

    public delete(itemId: number): Observable<DeleteResult | null> {

        const result = HttpCrudFactory.delete(this.http, this._controllerName, this._apiBaseUrl, itemId);

        return result;
    }
}

